const DBLNegocios1 = [{
    "tipoVenta": "ALTA_NUEVA",
    "tipoLinea": "LINEA_ADICIONAL",
    "tarifa": {
        "id": "NPOSCONVERGENTDBL11",
        "price": 64,
        "name": "Fibra 1 GB + Gigas Infinitos PRO",
        "operator": "DBL",
        "segment": "NEGOCIOS",
        "category": "convergent",
        "color": null,
        "commercial_enrichment": null,
        "description_file": null,
        "fixed_line_info": {
            "type": "",
            "owners": [],
            "upload_speed": {
                "unit": "Mb",
                "amount": 0
            },
            "download_speed": {
                "unit": "Mb",
                "amount": 0
            },
            "voice_to_fixed": {
                "unit": "min",
                "amount": 0
            },
            "voice_to_mobile": {
                "unit": "min",
                "amount": 0
            }
        },
        "mobile_line_info": {
            "mobile_line_data": {
                "unit": "GB",
                "amount": 0
            },
            "mobile_line_voice": {
                "unit": "min",
                "amount": 0
            }
        },
        "payment_type": "postpaid",
        "is_active": true,
        "created_on": "2022-05-25T00:45:13.938041+02:00",
        "updated_on": "2022-05-25T00:45:13.946057+02:00",
        "svas": [],
        "promotions": [
            "PROMODBL11",
            "PROMODBL12",
            "PROMODBL13",
            "PROMODBL5",
            "PROMODBL7",
            "PROMOYOIGO23",
            "PROMODBL14"
        ],
        "additional_lines": [
            "NLADUO(ADICIONAL)PRODBL",
            "NLADUO(PRINCIPAL)PRODBL",
            "NLASINFIN25GBADICIONALPRODBL",
            "NLASINFIN60GBADICIONALPRODBL",
            "NLASINFINGIGASINFINITOSADICIONALPRODBL"
        ]
    },
    "cacharro": null,
    "installment": null,
    "seguro": null,
    "lineasAsociadas": [],
    "crossSell": false,
    "promotion": [
        {
            "id": "PROMODBL12",
            "duration": 3,
            "name": "Convergente 1Gb A Precio 300Mb PRO",
            "duration_unit": "month",
            "amount": "12.00",
            "amount_unit": "MONETARY",
            "is_active": true,
            "observations": "Valido para altas nuevas o portabilidades de fijo y movil",
            "operator": "DBL"
        },
        {
            "id": "PROMODBL5",
            "duration": 0,
            "name": "Descuento Multisede 10",
            "duration_unit": null,
            "amount": "10.00",
            "amount_unit": "MONETARY",
            "is_active": true,
            "observations": "Tiene que tener contratada al menos una convergente PRO de Gigas Infinitos o 40Gb",
            "operator": "DBL"
        }
    ]
}]
export default DBLNegocios1;